import type { CityConfig } from "../city-template/types";

export const poplarBluffMOConfig: CityConfig = {
  city: "Poplar Bluff",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "poplar-bluff-mo",
  route: "/cities/poplar-bluff-mo",
  title: "Emergency Passport Poplar Bluff, MO | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Poplar Bluff, MO — as fast as 24 hours. Serving Butler County and the Ozark foothills region. A+ BBB rated registered State Dept. courier serving Poplar Bluff, Dexter, Doniphan, and southeast Missouri. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Poplar Bluff, MO",
  heroSubtitle: "Ozark foothills business trip to Toronto next week and your passport expired? Black River float trip turns into a Canada vacation with expired documents? Butler County family cruise from Miami in two weeks? We help Poplar Bluff residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Poplar%20Bluff%20Missouri%20Butler%20County%20downtown%20historic%20district%20Black%20River%20winding%20through%20Ozark%20foothills%20Mark%20Twain%20National%20Forest%20surrounding%20landscape%20Three%20Rivers%20College%20campus%20red%20brick%20buildings%20southern%20Missouri%20charm%20rolling%20green%20hills%20professional%20drone%20photography%20Heartland%20Ozark%20community%20and%20natural%20beauty%20at%20the%20edge%20of%20the%20Bootheel&width=1800&height=700&seq=poplar-bluff-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Poplar Bluff Missouri Black River Ozark foothills Butler County at golden hour",
  geoPosition: "36.7570;-90.3925",
  geoPlacename: "Poplar Bluff, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 510 miles north of Poplar Bluff via I-55/I-57",
  },
  nearbyCitiesZips: [
    { name: "Poplar Bluff", zips: "63901, 63902" },
    { name: "Dexter", zips: "63841" },
    { name: "Doniphan", zips: "63935" },
    { name: "Piedmont", zips: "63957" },
    { name: "Van Buren", zips: "63965" },
    { name: "Bloomfield", zips: "63825" },
    { name: "Advance", zips: "63730" },
    { name: "Bernie", zips: "63822" },
    { name: "Malden", zips: "63863" },
    { name: "Puxico", zips: "63960" },
    { name: "Ellsinore", zips: "63937" },
    { name: "Greenville", zips: "63944" },
    { name: "Mountain Grove", zips: "65711" },
    { name: "West Plains", zips: "65775" },
    { name: "Sikeston", zips: "63801" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Butler County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Ozark Foothills Hub", desc: "Serving Poplar Bluff, Dexter, Doniphan, and the Black River region" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cape Girardeau, MO", route: "/cities/cape-girardeau" },
    { name: "Fast passport renewal in Springfield, MO", route: "/cities/springfield-mo" },
    { name: "Emergency passport help in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Urgent passport services in Memphis, TN", route: "/cities/memphis" },
    { name: "Passport courier services in Columbia, MO", route: "/cities/columbia-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Poplar Bluff remotely via secure courier. We do not have a walk-in office in Poplar Bluff — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Butler County, the Ozark foothills, and southeast Missouri.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Butler County including Poplar Bluff, Dexter, Doniphan, and the southeast Missouri Ozark foothills",
  serviceAreaIntro: "From the Black River winding through the Ozark foothills at Poplar Bluff to the Mark Twain National Forest trails of Carter and Ripley counties, from Three Rivers College and the growing medical corridor of Poplar Bluff to the agricultural communities of Butler County stretching into the Bootheel — Fast Passport Center serves the entire southeast Missouri region. We regularly help Three Rivers College students, Ozark National Scenic Riverways visitors, and Butler County families get their passports fast without the drive to Chicago, St. Louis, or Memphis.",
  nearbyCitiesIntro: "We serve all Poplar Bluff neighborhoods and the surrounding area including Dexter, Doniphan, Piedmont, and Bloomfield. If you are anywhere in Butler County, Ripley County, Wayne County, or the Ozark foothills, we have you covered.",
  howItWorksIntro: "Most Poplar Bluff travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Poplar Bluff travelers face significant distances to any regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Poplar Bluff and Butler County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Poplar Bluff? Here are the most common ones we hear from Ozark foothills travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Poplar Bluff travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Randy J.",
      location: "Poplar Bluff, MO",
      rating: 5,
      text: "Three Rivers College faculty trip to Oxford University — realized my passport had expired 4 days before the flight. Fast Passport Center got it done in 27 hours. From Poplar Bluff to the UK. Unbelievable service!",
      service: "Passport Renewal",
    },
    {
      name: "Melissa W.",
      location: "Dexter, MO",
      rating: 5,
      text: "Medical mission trip to Guatemala through our church. Fast Passport Center processed my emergency passport in 26 hours. The dedicated agent walked me through everything. Butler County's best-kept secret!",
      service: "Emergency Passport",
    },
    {
      name: "Derek P.",
      location: "Doniphan, MO",
      rating: 5,
      text: "Ozark National Scenic Riverways tour group going to Canada — both kids needed first passports. Fast Passport Center guided us through the child process in 4 days. Ozark foothills families, this is the service you need!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "poplar-bluff-1",
      name: "Poplar Bluff Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "430 Poplar St",
      city: "Poplar Bluff",
      state: "MO",
      zip: "63901",
      phone: "(573) 785-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Poplar Bluff",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Poplar Bluff facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "poplar-bluff-2",
      name: "Butler County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "100 N Main St",
      city: "Poplar Bluff",
      state: "MO",
      zip: "63901",
      phone: "(573) 686-8082",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Poplar Bluff Courthouse",
      website: "https://www.butlercountymo.com",
      websiteLabel: "Butler County Circuit Clerk",
      notes: "County seat with passport acceptance services. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "poplar-bluff-3",
      name: "Dexter Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 E Stoddard St",
      city: "Dexter",
      state: "MO",
      zip: "63841",
      phone: "(573) 624-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles east of Poplar Bluff",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Stoddard County area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "poplar-bluff-4",
      name: "Doniphan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 Washington St",
      city: "Doniphan",
      state: "MO",
      zip: "63935",
      phone: "(573) 996-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles southwest of Poplar Bluff",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Ripley County area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "poplar-bluff-5",
      name: "Piedmont Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 W Fir St",
      city: "Piedmont",
      state: "MO",
      zip: "63957",
      phone: "(573) 223-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles northwest of Poplar Bluff",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wayne County area. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Poplar Bluff photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Butler County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Poplar Bluff applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Ozark foothills families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Poplar Bluff travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Poplar Bluff." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Poplar Bluff address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Poplar Bluff before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Poplar Bluff for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Poplar Bluff?", a: "Fast Passport Center offers fast passport renewal in Poplar Bluff in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Poplar Bluff?", a: "The nearest regional passport agency to Poplar Bluff is the Chicago Passport Agency, approximately 510 miles north via I-55/I-57. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Poplar Bluff without any in-person agency visit required." },
    { q: "Do you serve the entire Ozark foothills region?", a: "Absolutely. Fast Passport Center serves the entire Ozark foothills region including Poplar Bluff, Dexter, Doniphan, Piedmont, and surrounding areas. Our courier service works seamlessly from any address in Butler, Ripley, Wayne, or Carter counties." },
    { q: "Can I get a same-day passport appointment near Poplar Bluff?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 6+ hour drive from Poplar Bluff — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Butler County residents." },
    { q: "Do you serve Three Rivers College students?", a: "Absolutely. Fast Passport Center proudly serves Three Rivers College students and faculty needing urgent passport services for study abroad, academic conferences, and international travel. Our courier service handles everything — no campus post office lines needed." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Poplar Bluff with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Can I expedite a child passport in Poplar Bluff?", a: "Yes. Fast Passport Center expedites child passports in Poplar Bluff for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Butler County and Ozark foothills families through the entire process." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Poplar Bluff", address: "1900 N Westwood Blvd, Poplar Bluff, MO 63901", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Poplar Bluff", address: "110 S Westwood Blvd, Poplar Bluff, MO 63901", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Dexter", address: "1803 W Business Highway 60, Dexter, MO 63841", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walmart Supercenter — West Plains", address: "1310 Preacher Roe Blvd, West Plains, MO 65775", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Poplar Bluff License Office",
      address: "1900 N Westwood Blvd, Poplar Bluff, MO 63901",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Poplar Bluff and Butler County residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — Dexter License Office",
      address: "515 W Business Highway 60, Dexter, MO 63841",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Stoddard County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — West Plains License Office",
      address: "1300 Preacher Roe Blvd, West Plains, MO 65775",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Howell County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "POF",
      name: "Poplar Bluff Regional Airport",
      distance: "3 miles east of Poplar Bluff",
      address: "2001 Tower Road, Poplar Bluff, MO 63901",
      note: "Regional general aviation airport. About 8 minutes from downtown Poplar Bluff.",
      flightUrl: "https://www.poplarbluffbusinessfirst.com/airport",
      flightLabel: "POF Airport",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "170 miles north of Poplar Bluff",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with worldwide connections. About 2 hours 40 minutes from Poplar Bluff via US-67/I-55.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
    {
      code: "MEM",
      name: "Memphis International Airport",
      distance: "160 miles south of Poplar Bluff",
      address: "2491 Winchester Rd, Memphis, TN 38116",
      note: "Major international airport with global FedEx hub. About 2 hours 45 minutes from Poplar Bluff.",
      flightUrl: "https://www.flymemphis.com/",
      flightLabel: "MEM Airport",
      featured: false,
    },
  ],
};